export default "__VITE_ASSET__d195b0e8__"